import HistoryProgramLinksSection from 'components/Content/BeautyInsider/BeautyInsiderHistory/HistoryProgramLinksSection/HistoryProgramLinksSection';

export default HistoryProgramLinksSection;
